module.exports = __webpack_public_path__ + "static/chenmed-923ea2baa624521b2bfe3bab782589e3.jpg";